import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {DayOfTheWeek, OpeningTimesTable} from './ContactPage.style';
import {CLOSED} from '../../constants/constant';

// DAYS of the week keys, in the order we want to display them
const DAYS_OF_THE_WEEK = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

// We show this if the restaurant is closed on that day
const NO_DAY_DATA = [CLOSED];

const getOpeningTimesForEveryDay = (openingTimes) => {
  const output = [];
  DAYS_OF_THE_WEEK.forEach((dayOfTheWeek) => {
    output.push(openingTimes[dayOfTheWeek] || NO_DAY_DATA);
  });
  return output;
};

class OpeningTimes extends PureComponent {
  constructor(props) {
    super(props);
    this.openingTimesDisplay = getOpeningTimesForEveryDay(props.openingTimes);
  }

  renderTimeData(openingTimesMapped, index) {
    return openingTimesMapped.map((time, i) => (time === CLOSED) ? <div key={`close${i}`}>CLOSED</div> :
      <div key={`${DAYS_OF_THE_WEEK[index]}-${time.from}`}>{time.from} - {time.to}</div>);
  }

  render() {
    return (
      <OpeningTimesTable>
        <tbody>
        {this.openingTimesDisplay.map((openingTimesMapped, index) =>
          <tr key={DAYS_OF_THE_WEEK[index]}>
            <DayOfTheWeek>{DAYS_OF_THE_WEEK[index].toLowerCase()}</DayOfTheWeek>
            <td>
              {/* Return the to from time in a div OR return only a string (NO_DAY_DATA) */}
              {this.renderTimeData(openingTimesMapped, index)}
            </td>
          </tr>
        )}
        </tbody>
      </OpeningTimesTable>
    );
  }
}

OpeningTimes.propTypes = {
  openingTimes: PropTypes.object.isRequired
};

export default OpeningTimes;



// WEBPACK FOOTER //
// ./containers/ContactPage/OpeningTimes.js